module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ident"
  }, [_c('div', {
    staticClass: "collec",
    attrs: {
      "id": "collec0"
    }
  }, [_c('a', {
    attrs: {
      "id": "collec"
    }
  }), _c('h1', {
    staticClass: "collec_tit"
  }, [_c('a', {
    attrs: {
      "id": "collec"
    }
  }, [_c('span')]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('i', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")])]), _c('br'), _c('i', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROJECT")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAM")])])])]), _c('p', {
    staticClass: "cint_collec"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('b', [_vm._v("Thomas C.Oden")])])])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "cint_collec"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSOCIATE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('b', [_vm._v("Christopher A. Hall")])])])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "cint_collec"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PERATIONS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANAGER AND")]), _c('br'), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLATIONS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROJECT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OORDINATOR")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Joel Elowsky")])])])])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "cint_collec"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH AND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CQUISITIONS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTOR")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Michael Glerup")])])])])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "cint_collec"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITORIAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVICES")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTOR")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Warren Calhoun Robertson")])])])])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "cint_collec"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANGUAGE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSION")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTOR")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Konstantin Gavrilkin")])])])])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "cint_collec"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RADUATE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSISTANTS")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("Marco Conti"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Susan Kipper")])])])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("Jeffrey Finch"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Hsueh-Ming Liao")])])])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("Grant Gieseke"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Michael Nausner")])])])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("Steve Finlan"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Joel Scandrett")])])])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("James A. Kellerman"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Baek-Yong Sung")])])])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("Alexei Khamine"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Elena Vishnevskaya")])])])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("Vladimir Kharlamov"), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Jeffery Wittung")])])])])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DMINISTRATIVE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSISTANT")])])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVII"
    }
  }, [_c('span', [_c('i', [_vm._v("Judy Cincotta")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61ecee2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ident12.vue
// module id = 60
// module chunks = 0